import { getFileNameByUrl } from "../helper/url.helper";

export const handleDownload = (url: string) => {
  const downloadLink = document.createElement("a");
  downloadLink.href = url;
  downloadLink.download = getFileNameByUrl(url);
  downloadLink.click();
};